// extracted by css-extract-rspack-plugin
export default {"cls1":"ResearchExamples-cls1_-8z","cls2":"ResearchExamples-cls2_Lww ResearchExamples-cls1_-8z"};